<template>
  <ElCard :class="s.topInfo">
    <div :class="s.top">
      <div id="left" ref="left" class="left">
        <div class="top-three">
          <div class="item">
            <div class="number">{{ total.consult_count || 0 }}</div>
            <div class="intro">智能诊断</div>
          </div>
          <div class="item two">
            <div class="number">{{ total.user_count || 0 }}</div>
            <div class="intro">会员总数</div>
          </div>
          <div class="item three">
            <div class="number">{{ total.test_count || 0 }}</div>
            <div class="intro">评测总数</div>
          </div>
          <div>
            <countdown
              ref="countdown"
              class="countdown_box"
              :time="5 * 60 * 1000"
              @end="handleCountdownEnd"
            >
              <template slot-scope="props">
                <span class="count_text">
                  {{ props.minutes.toString().padStart(2, 0) }}:
                  {{ props.seconds.toString().padStart(2, 0) }}
                </span>
                <span>后页面刷新</span>
              </template>
            </countdown>
          </div>
        </div>
        <section ref="main" class="main"></section>
      </div>
      <div class="right">
        <div class="birthday-notice" @click="showBirthday">
          {{ birthdayNumber }}
        </div>
        <div class="today">
          <div class="item">
            <div class="number">{{ todayNum.user_count || 0 }}</div>
            <div class="intro">今日新客</div>
          </div>
          <div class="item">
            <div class="number">{{ todayNum.consult_count || 0 }}</div>
            <div class="intro">今日智能诊断</div>
          </div>
          <div class="item">
            <div class="number">{{ todayNum.test_count || 0 }}</div>
            <div class="intro">今日评测</div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="580px"
      custom-class="show_dialog_title"
    >
      <div slot="title" class="dialog_title">
        <div class="flex">
          <div class="circle"></div>
          <span>生日提醒</span>
        </div>
      </div>
      <div class="dialog_content">
        <div class="subtitle">
          今日过生日的宝宝：共{{ brithdayData[0].length }}人
        </div>
        <div
          v-for="(item, index) in brithdayData[0]"
          :key="index"
          class="content"
        >
          <div class="num">{{ index + 1 }}、</div>
          <div class="text">{{ item }}</div>
        </div>
        <div class="subtitle">
          七天后过生日的宝宝：共{{ brithdayData[1].length }}人
        </div>
        <div
          v-for="(item, index) in brithdayData[1]"
          :key="item"
          class="content"
        >
          <div class="num">{{ index + 1 }}、</div>
          <div class="text">{{ item }}</div>
        </div>
      </div>
    </el-dialog>
  </ElCard>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown';
import echarts from 'echarts';
import {http, catchAppError} from '@/util';
import url from '@/config';

export default {
  name: 'TopInfo',
  components: {
    countdown: VueCountdown
  },
  data() {
    return {
      total: {},
      todayNum: {},
      diagram: [],
      dialogVisible: false,
      brithdayData: [[], []]
    };
  },
  computed: {
    birthdayNumber() {
      const [one, two] = this.brithdayData;
      return one.length + two.length;
    }
  },
  watch: {
    diagram() {
      this.initEachrt();
    }
  },
  async beforeMount() {
    await this._timeInterval();
  },
  methods: {
    handleCountdownEnd() {
      this.$refs.countdown.end();
      this.$refs.countdown.totalMilliseconds = 5 * 60 * 1000;
      this.$refs.countdown.start();
    },

    async _timeInterval() {
      await this._getData();
      setTimeout(() => {
        this._timeInterval();
      }, 60000 * 5);
    },

    async _getData() {
      http
        .post(url.total)
        .then(res => {
          this.total = res;
        })
        .catch(catchAppError);
      http
        .post(url.todayNum)
        .then(res => {
          this.todayNum = res;
        })
        .catch(catchAppError);
      http
        .post(url.diagram)
        .then(res => {
          this.diagram = res;
        })
        .catch(catchAppError);
      this.brithdayData = await this.$http.post('/api/home/index/userBirthday');
    },

    async showBirthday() {
      this.dialogVisible = !!this.birthdayNumber;
    },
    initEachrt() {
      // 基于准备好的dom，初始化echarts实例
      this.$refs.main.style.width = `${this.$refs.left.clientWidth}px`;
      const myChart = echarts.init(this.$refs.main);

      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['智能诊断数', '评测数']
        },
        grid: {
          top: 30,
          bottom: 0,
          left: 20,
          right: 20,
          containLabel: true,
          show: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            splitLine: {
              show: true
            },
            data: this.diagram.map(res => res.time)
          }
        ],
        yAxis: {
          type: 'value',
          splitLine: {
            show: true
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: '智能诊断数',
            type: 'line',
            smooth: true,
            itemStyle: {normal: {color: '#73e7c4'}},
            lineStyle: {normal: {color: '#73e7c4'}},
            areaStyle: {
              normal: {
                color: '#98eed4'
              }
            },
            data: this.diagram.map(res => res.consult_count)
          },
          {
            name: '评测数',
            type: 'line',
            smooth: true,
            areaStyle: {
              normal: {
                color: '#6fddce'
              }
            },
            lineStyle: {normal: {color: '#4ec5f8'}},
            itemStyle: {normal: {color: '#4ec5f8'}},
            data: this.diagram.map(res => res.test_count)
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style>
.count_text {
  color: #4c90ff;
}

.countdown_box {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  padding: 20px;
  line-height: 58px;
  width: 151px;
  height: 58px;
  text-align: center;
  -webkit-box-shadow: 0px 4px 24px 0px rgba(75, 144, 255, 0.1);
  box-shadow: 0px 4px 24px 0px rgba(75, 144, 255, 0.1);
  border-radius: 4px;
  margin-bottom: 15px;
  padding-right: 40px;
}

.show_dialog_title {
  border-radius: 8px;
}

.show_dialog_title .el-dialog__close {
  color: #666;
}

.show_dialog_title .el-dialog__header {
  display: block;
}
</style>
<style scoped>
.dialog_title {
  padding-bottom: 10px;
  color: #666;
  font-size: 16px;
  border-bottom: 1px solid #dedede;
}

.dialog_title .flex {
  display: flex;
  align-items: center;
}

.dialog_title .circle {
  margin-right: 5px;
  width: 10px;
  height: 10px;
  background: #4c90ff;
  border-radius: 50%;
}

.dialog_content {
  margin-top: -20px;
  max-height: 800px;
  overflow: auto;
}

.dialog_content .subtitle {
  margin-bottom: 15px;
  color: #ff7022;
  font-size: 14px;
}

.dialog_content .content {
  margin-bottom: 10px;
  padding-left: 26px;
  color: #6a6a6a;
  font-size: 14px;
  position: relative;
}

.dialog_content .content .num {
  position: absolute;
  left: 0px;
  top: 8px;
}

.dialog_content .content .text {
  line-height: 30px;
}
</style>
<style lang="scss" module="s">
.top-info {
  :global {
    margin-bottom: 20px;
    .el-card__body {
      padding: 12px 0 30px;
    }
  }
  .top {
    :global {
      display: flex;
      .left {
        flex-grow: 3.521;
        width: 352.1px;
        border-right: 1px solid #ebebeb;
        .main {
          width: 600px;
          height: 160px;
          margin-top: 40px;
        }
        .top-three {
          display: flex;
          padding-top: 18px;
          padding-left: 30px;
          padding-right: 30px;
          .item {
            flex-grow: 1;
            padding-left: 45px;
            text-align: center;
            height: 45px;
            box-sizing: border-box;
            background-image: url(../../assets/img/main-icon1.png);
            background-repeat: no-repeat;
            &.two {
              background-position: 0 -82px;
            }
            &.three {
              background-position: 0 -163px;
            }
            .intro,
            .number {
              width: 80px;
            }
            .intro {
              font-size: 16px;
              width: 100px;
            }
            .number {
              margin-bottom: 8px;
              font-size: 20px;
              color: #4b90ff;
            }
          }
        }
      }
      .right {
        flex-grow: 1;
        width: 100px;
        padding-top: 8px;
        .birthday-notice {
          cursor: pointer;
          font-size: 48px;
          width: 156px;
          box-sizing: border-box;
          text-align: center;
          margin: 0 auto 50px;
          height: 70px;
          line-height: 70px;
          padding-right: 12px;
          padding-left: 88px;
          color: #fff;
          background-image: url(../../assets/img/main-icon1.png);
          box-shadow: 0 0 14px rgba($color: #4b90ff, $alpha: 0.5);
          background-position: 0 -266px;
          background-size: 100%;
          background-repeat: no-repeat;
        }
        .today {
          width: 170px;
          margin-left: auto;
          margin-right: auto;
          .item {
            padding-left: 40px;
            height: 44px;
            border-bottom: 1px solid #f7f7f7;
            background-image: url(../../assets/img/main-icon1.png);
            background-repeat: no-repeat;
            text-indent: 20px;
            position: relative;
            &:after {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              height: 1px;
              width: 40px;
              background-color: #29bb9b;
            }
            &:nth-child(1) {
              background-position: 0 -378px;
            }
            &:nth-child(2) {
              background-position: 0 -422px;
            }
            &:nth-child(3) {
              background-position: 0 -469px;
            }
            .number {
              color: #4b90ff;
              font-size: 16px;
              padding-top: 6px;
            }
            .intro {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss" module="dialog">
@import '@/assets/css/dialog.scss';
.ol {
  margin-top: 5px;
  padding-left: 30px;
  max-height: 350px;
  overflow-y: auto;
  :global {
    li {
      margin-bottom: 20px;
    }
  }
}
</style>
